export default {
  'intl-locale': 'es-419',
  system: {
    loading: 'Cargando...',
    error: {
      title: 'Falla en el Sistema',
      message:
        'Lo sentimos, hubo una falla en el sistema. Inténtelo nuevamente.'
    }
  },
  filter: {
    select: 'Seleccione',
    'btn-submit-text': 'Filtrar',
    'btn-clear-text': 'Limpiar',
    'nav-between-groups': 'Grupo de filtros {{group}}/{{totalGroup}}',
    'complement-or': 'Filtrar - Complementar (OR)',
    'refine-and': 'Filtrar - Refinar (AND)',
    loading: 'Cargando filtro...',
    filters: 'Filtros'
  },
  'filter-composition': {
    'label-field': 'Composición del Filtro'
  },
  filteractions: {
    'select-label': 'Acciones de Filtro',
    'initial-selection': 'Filtro inicial reiniciado'
  },
  pagination: {
    pages: 'Páginas',
    'go-to-page': 'Ir a la página'
  },
  'data-table': {
    selection: 'Selección',
    actions: 'Acciones',
    'no-records-found': 'No se encontraron registros',
    'select-all': 'Seleccionar todos',
    'navigate-between-table-columns': 'Navegar entre columnas de la tabla',
    previous: 'Anterior',
    next: 'Siguiente'
  },
  multifree: {
    item: 'ítem',
    items: 'ítems',
    add: 'agregar',
    remove: 'eliminar',
    clear: 'limpiar'
  },
  uniselection: {
    clear: 'limpiar',
    'show-options': 'mostrar opciones',
    'hide-options': 'ocultar opciones'
  },
  multiselection: {
    clear: 'limpiar',
    'show-options': 'mostrar opciones',
    'hide-options': 'ocultar opciones',
    selection: 'selección',
    selections: 'selecciones',
    'option-selected': 'opción seleccionada',
    'options-selected': 'opciones seleccionadas',
    selections_one: '{{count}} selección',
    selections_multiple: '{{count}} selecciones'
  },
  datepicker: {
    select: 'Seleccionar'
  },
  'navigation-slider': {
    previous: 'Ir al anterior',
    next: 'Ir al siguiente',
    beginning: 'Ir al inicio',
    last: 'Ir al último',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña'
  },
  task: {
    model: 'Modelo de Tarea',
    sid: 'SID de la Tarea',
    'assigned-requester': 'Solicitante Asignado',
    'assigned-executor': 'Ejecutor Asignado',
    'scheduled-submission': 'Envío Programado en',
    'scheduled-start': 'Inicio Programado en',
    priority: {
      low: 'baja',
      normal: 'normal',
      high: 'alta',
      urgent: 'urgente'
    },
    action: {
      approve: 'Aprobar',
      cancel: 'Cancelar',
      copy: 'Copiar',
      deliver: 'Entregar',
      lock: 'Bloquear',
      'mark-as-failed': 'Marcar como fallida',
      pause: 'Pausar',
      reject: 'Rechazar',
      restart: 'Reiniciar',
      resume: 'Reanudar',
      return: 'Devolver',
      start: 'Iniciar',
      take: 'Asumir',
      unlock: 'Desbloquear',
      view: 'Visualizar',
      execute: 'Ejecutar'
    }
  },
  'loading-page': {
    heading: 'La página se está cargando',
    complement: 'Esto puede tomar algunos minutos.\nPor favor, espere.'
  },
  'transfer-order-card': {
    shipper: 'Transportista',
    receiver: 'Receptor',
    'delivery-order': 'Orden de Entrega',
    'receipt-order': 'Orden de Recepción',
    'order-table-header': 'Orden | Descripción | Cantidad | Unidad de Medida',
    view: 'Visualizar'
  },
  'route-section': {
    'sid-label': 'SID de Ruta',
    estimated: 'Tiempo Estimado y KM Estimado'
  },
  'transport-card': {
    route: 'Ruta',
    checkpoints: 'Puntos de Control'
  },
  'checkpoint-section': {
    status: {
      todo: 'Por visitar',
      doing: 'Iniciado',
      done: 'Finalizado'
    },
    'map-button': 'Mapa',
    view: 'Visualizar',
    'transfer-order': 'Órdenes de Transferencia'
  },
  'priority-tag': {
    low: 'baja',
    normal: 'normal',
    high: 'alta',
    urgent: 'urgente'
  },
  'training-card': {
    duration: 'Duración',
    seconds: 'segundos',
    minutes: 'minutos',
    'play-video': 'reproducir video'
  },
  '503-error': {
    title: 'Estamos Temporalmente Indisponibles',
    'description-1':
      'Nuestros servicios están fuera de servicio en este momento.',
    'description-2':
      'Por favor, regrese a la página de inicio o intente nuevamente en unos momentos.',
    'try-again': 'Intentar de nuevo',
    'alt-img': 'Error 503'
  },
  saf: {
    legend: 'Leyenda',
    in: 'Entradas',
    out: 'Salidas',
    'initial-stock': 'Stock inicial',
    'final-stock': 'Stock final',
    totals: 'Totales'
  },
  'text-fading': {
    'read-more': 'Leer más',
    'read-less': 'Leer menos'
  },
  accordion: {
    'summary-item': 'Elemento de resumen',
    'toggle-accordion': 'Alternar acordeón'
  },
  'contact-object-card': {
    'phone-number': 'Número de teléfono'
  }
}
